import React from 'react';
import { VideoItemRating } from '../../video-item-rating';

export const MetadataRating = ({ ratingAvg, listElement }) =>
  listElement ? (
    <span className="ct-video-additional-metadata__list-elem">
      <VideoItemRating averageRating={ratingAvg} />
    </span>
  ) : (
    <VideoItemRating averageRating={ratingAvg} />
  );
